import { env } from './utils/getEnv';

export default () => ({
    url: env.REACT_APP_AUTH_URL,
    realm: env.REACT_APP_AUTH_REALM,
    clientId: env.REACT_APP_AUTH_CLIENT_ID
  });
